import React from 'react';
import { Stack } from '@mui/material';
import { Button, Box, Typography } from 'components/index';
import { SentimentVeryDissatisfied, ArrowBackIos, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../common/constants/urls';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box textAlign={'center'} sx={{ marginTop: '100px' }}>
      <Stack spacing={2} alignItems={'center'}>
        <Typography variant='h2' fontWeight={'bold'}>
          404 - Page Not Found
        </Typography>
        <Typography>Sorry, the page you are looking for does not exist.</Typography>
        <SentimentVeryDissatisfied sx={{ fontSize: '7em' }} color='secondary' />
        <Stack direction={'row'} spacing={2}>
          <Button variant='contained' onClick={() => navigate(-1)} startIcon={<ArrowBackIos />}>
            Go Back
          </Button>
          <Button variant='contained' onClick={() => navigate(ROUTES.HOME)} startIcon={<Home />}>
            Go Home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default NotFound;
